<template>
  <div
    data-elementor-type="wp-post"
    data-elementor-id="1665"
    class="elementor elementor-1665"
    data-elementor-post-type="post"
  >
    <div
      class="elementor-element elementor-element-c1a303b e-con-full e-flex e-con e-parent e-lazyloaded"
      data-id="c1a303b"
      data-element_type="container"
      data-e-type="container"
    >
      <div
        class="elementor-element elementor-element-84cded0 elementor-widget elementor-widget-html"
        data-id="84cded0"
        data-element_type="widget"
        data-e-type="widget"
        data-widget_type="html.default"
      >
        <section
          id="cdf-tipo-flete-v9"
          aria-labelledby="cdf-tipo-flete-v9-title"
        >
          <link
            href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&amp;display=swap"
            rel="stylesheet"
          />

          <link
            rel="stylesheet"
            href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.0/css/all.min.css"
            crossorigin="anonymous"
            referrerpolicy="no-referrer"
          />

          <div class="tf9-container">
            <header class="tf9-header">
              <span class="tf9-label">
                <i class="fa-solid fa-layer-group" aria-hidden="true"></i>

                Opciones de envío
              </span>

              <h2 id="cdf-tipo-flete-v9-title">Selecciona el tipo de flete</h2>

              <div class="tf9-title-line" aria-hidden="true"></div>
            </header>

            <div class="tf9-grid">
              <!-- =================================================
           01 — CARGA CONSOLIDADA
      ================================================== -->

              <article class="tf9-card tf9-card--lcl">
                <a
                  class="tf9-link"
                  @click="irARuta('LCL')"
                  aria-label="Seleccionar carga compartida, consolidada o grupal"
                >
                  <span class="tf9-number"> 01 </span>

                  <span class="tf9-icon-area">
                    <span class="tf9-icon-box">
                      <svg
                        class="tf9-lcl-svg"
                        viewBox="0 0 160 120"
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                      >
                        <ellipse
                          cx="80"
                          cy="108"
                          rx="58"
                          ry="5"
                          fill="#E6EAED"
                        ></ellipse>

                        <rect
                          x="22"
                          y="88"
                          width="116"
                          height="8"
                          rx="2"
                          fill="#745238"
                        ></rect>

                        <rect
                          x="31"
                          y="96"
                          width="18"
                          height="5"
                          rx="1"
                          fill="#593B27"
                        ></rect>

                        <rect
                          x="71"
                          y="96"
                          width="18"
                          height="5"
                          rx="1"
                          fill="#593B27"
                        ></rect>

                        <rect
                          x="111"
                          y="96"
                          width="18"
                          height="5"
                          rx="1"
                          fill="#593B27"
                        ></rect>

                        <g stroke="#8B6342" stroke-width="1.5">
                          <rect
                            x="27"
                            y="59"
                            width="34"
                            height="29"
                            rx="2.5"
                            fill="#C58D56"
                          ></rect>

                          <path d="M44 59V88 M27 68H61" fill="none"></path>

                          <rect
                            x="64"
                            y="51"
                            width="31"
                            height="37"
                            rx="2.5"
                            fill="#B97943"
                          ></rect>

                          <path d="M79.5 51V88 M64 61H95" fill="none"></path>

                          <rect
                            x="98"
                            y="61"
                            width="33"
                            height="27"
                            rx="2.5"
                            fill="#D2A06A"
                          ></rect>

                          <path d="M114.5 61V88 M98 70H131" fill="none"></path>

                          <rect
                            x="35"
                            y="35"
                            width="28"
                            height="22"
                            rx="2.5"
                            fill="#D8AA74"
                          ></rect>

                          <path d="M49 35V57" fill="none"></path>

                          <rect
                            x="67"
                            y="24"
                            width="36"
                            height="25"
                            rx="2.5"
                            fill="#C58B53"
                          ></rect>

                          <path d="M85 24V49 M67 33H103" fill="none"></path>

                          <rect
                            x="106"
                            y="40"
                            width="23"
                            height="19"
                            rx="2.5"
                            fill="#AE6E3B"
                          ></rect>

                          <path d="M117.5 40V59" fill="none"></path>
                        </g>
                      </svg>
                    </span>
                  </span>

                  <h3>
                    <span class="tf9-title-line-mobile">
                      Carga compartida /
                    </span>

                    <span class="tf9-title-line-mobile">
                      Consolidada o Grupal
                    </span>
                  </h3>

                  <span class="tf9-divider" aria-hidden="true"></span>

                  <p class="tf9-mode">
                    <i class="fa-solid fa-ship" aria-hidden="true"></i>

                    Vía marítima
                  </p>

                  <span class="tf9-action">
                    <span> Seleccionar </span>

                    <i class="fa-solid fa-arrow-right" aria-hidden="true"></i>
                  </span>
                </a>
              </article>

              <!-- =================================================
           02 — CONTENEDOR FCL
      ================================================== -->

              <article class="tf9-card tf9-card--fcl">
                <a
                  class="tf9-link"
                  @click="irARuta('FCL')"
                  target="_blank"
                  rel="noopener"
                  aria-label="Seleccionar contenedor completo FCL"
                >
                  <span class="tf9-number"> 02 </span>

                  <span class="tf9-icon-area">
                    <span class="tf9-icon-box">
                      <svg
                        class="tf9-fcl-svg"
                        viewBox="0 0 360 220"
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                      >
                        <defs>
                          <linearGradient
                            id="tf9-fcl-side"
                            x1="0"
                            y1="0"
                            x2="1"
                            y2="0"
                          >
                            <stop offset="0%" stop-color="#D24A3C"></stop>

                            <stop offset="45%" stop-color="#BE352C"></stop>

                            <stop offset="100%" stop-color="#941F1D"></stop>
                          </linearGradient>

                          <linearGradient
                            id="tf9-fcl-front"
                            x1="0"
                            y1="0"
                            x2="1"
                            y2="1"
                          >
                            <stop offset="0%" stop-color="#B8322B"></stop>

                            <stop offset="100%" stop-color="#741719"></stop>
                          </linearGradient>

                          <linearGradient
                            id="tf9-fcl-roof"
                            x1="0"
                            y1="0"
                            x2="0"
                            y2="1"
                          >
                            <stop offset="0%" stop-color="#F0715D"></stop>

                            <stop offset="100%" stop-color="#8A1C1A"></stop>
                          </linearGradient>

                          <radialGradient
                            id="tf9-fcl-shadow"
                            cx="50%"
                            cy="50%"
                            rx="50%"
                            ry="50%"
                          >
                            <stop
                              offset="0%"
                              stop-color="#5E6870"
                              stop-opacity=".30"
                            ></stop>

                            <stop
                              offset="100%"
                              stop-color="#5E6870"
                              stop-opacity="0"
                            ></stop>
                          </radialGradient>
                        </defs>

                        <ellipse
                          cx="178"
                          cy="191"
                          rx="143"
                          ry="12"
                          fill="url(#tf9-fcl-shadow)"
                        ></ellipse>

                        <polygon
                          points="
                    28,59
                    246,34
                    246,164
                    28,187
                  "
                          fill="url(#tf9-fcl-side)"
                          stroke="#611416"
                          stroke-width="3"
                          stroke-linejoin="round"
                        ></polygon>

                        <polygon
                          points="
                    28,59
                    246,34
                    326,53
                    108,79
                  "
                          fill="url(#tf9-fcl-roof)"
                          stroke="#611416"
                          stroke-width="2.5"
                          stroke-linejoin="round"
                        ></polygon>

                        <g stroke="#84201D" stroke-width="2.25" opacity=".94">
                          <line x1="42" y1="58" x2="42" y2="185"></line>
                          <line x1="56" y1="56" x2="56" y2="184"></line>
                          <line x1="70" y1="55" x2="70" y2="182"></line>
                          <line x1="84" y1="53" x2="84" y2="181"></line>
                          <line x1="98" y1="51" x2="98" y2="179"></line>
                          <line x1="112" y1="50" x2="112" y2="177"></line>
                          <line x1="126" y1="48" x2="126" y2="176"></line>
                          <line x1="140" y1="46" x2="140" y2="174"></line>
                          <line x1="154" y1="45" x2="154" y2="173"></line>
                          <line x1="168" y1="43" x2="168" y2="171"></line>
                          <line x1="182" y1="42" x2="182" y2="170"></line>
                          <line x1="196" y1="40" x2="196" y2="168"></line>
                          <line x1="210" y1="38" x2="210" y2="167"></line>
                          <line x1="224" y1="37" x2="224" y2="165"></line>
                          <line x1="238" y1="35" x2="238" y2="164"></line>
                        </g>

                        <g stroke="#EF6A58" stroke-width=".9" opacity=".36">
                          <line x1="49" y1="57" x2="49" y2="182"></line>
                          <line x1="77" y1="54" x2="77" y2="179"></line>
                          <line x1="105" y1="50" x2="105" y2="176"></line>
                          <line x1="133" y1="47" x2="133" y2="173"></line>
                          <line x1="161" y1="44" x2="161" y2="170"></line>
                          <line x1="189" y1="41" x2="189" y2="167"></line>
                          <line x1="217" y1="37" x2="217" y2="164"></line>
                        </g>

                        <polygon
                          points="
                    28,178
                    246,156
                    246,165
                    28,188
                  "
                          fill="#5B1214"
                        ></polygon>

                        <polygon
                          points="
                    246,34
                    326,53
                    326,182
                    246,164
                  "
                          fill="url(#tf9-fcl-front)"
                          stroke="#571114"
                          stroke-width="3"
                          stroke-linejoin="round"
                        ></polygon>

                        <line
                          x1="286"
                          y1="43.5"
                          x2="286"
                          y2="173"
                          stroke="#4C0E11"
                          stroke-width="3"
                        ></line>

                        <polygon
                          points="
                    253,45
                    279,51
                    279,153
                    253,147
                  "
                          fill="none"
                          stroke="#571215"
                          stroke-width="1.7"
                        ></polygon>

                        <polygon
                          points="
                    293,55
                    319,61
                    319,174
                    293,168
                  "
                          fill="none"
                          stroke="#571215"
                          stroke-width="1.7"
                        ></polygon>

                        <g stroke="#8A211E" stroke-width="1.45" opacity=".88">
                          <line x1="258" y1="47" x2="258" y2="148"></line>
                          <line x1="265" y1="49" x2="265" y2="150"></line>
                          <line x1="272" y1="50" x2="272" y2="152"></line>

                          <line x1="298" y1="57" x2="298" y2="169"></line>
                          <line x1="305" y1="59" x2="305" y2="171"></line>
                          <line x1="312" y1="60" x2="312" y2="173"></line>
                        </g>

                        <g
                          stroke="#EEF1F2"
                          stroke-width="4.1"
                          stroke-linecap="round"
                        >
                          <line x1="257" y1="45" x2="257" y2="149"></line>
                          <line x1="276" y1="50" x2="276" y2="154"></line>
                          <line x1="296" y1="55" x2="296" y2="169"></line>
                          <line x1="315" y1="60" x2="315" y2="174"></line>
                        </g>

                        <g stroke="#7D878D" stroke-width="1.1" opacity=".9">
                          <line x1="259" y1="45" x2="259" y2="149"></line>
                          <line x1="278" y1="50" x2="278" y2="154"></line>
                          <line x1="298" y1="55" x2="298" y2="169"></line>
                          <line x1="317" y1="60" x2="317" y2="174"></line>
                        </g>

                        <g fill="#E5E9EB">
                          <rect
                            x="251"
                            y="67"
                            width="23"
                            height="4"
                            rx="1"
                            transform="rotate(14 251 67)"
                          ></rect>

                          <rect
                            x="251"
                            y="99"
                            width="23"
                            height="4"
                            rx="1"
                            transform="rotate(14 251 99)"
                          ></rect>

                          <rect
                            x="251"
                            y="131"
                            width="23"
                            height="4"
                            rx="1"
                            transform="rotate(14 251 131)"
                          ></rect>

                          <rect
                            x="292"
                            y="77"
                            width="25"
                            height="4"
                            rx="1"
                            transform="rotate(14 292 77)"
                          ></rect>

                          <rect
                            x="292"
                            y="110"
                            width="25"
                            height="4"
                            rx="1"
                            transform="rotate(14 292 110)"
                          ></rect>

                          <rect
                            x="292"
                            y="143"
                            width="25"
                            height="4"
                            rx="1"
                            transform="rotate(14 292 143)"
                          ></rect>
                        </g>

                        <g fill="none" stroke="#F4F5F6" stroke-width="2.1">
                          <path d="M261 84h10v8h-10"></path>
                          <path d="M301 94h10v8h-10"></path>

                          <path d="M261 116h10v8h-10"></path>
                          <path d="M301 127h10v8h-10"></path>
                        </g>

                        <polygon
                          points="
                    252,52
                    274,57
                    274,73
                    252,68
                  "
                          fill="#F0F2F3"
                        ></polygon>

                        <line
                          x1="256"
                          y1="59"
                          x2="270"
                          y2="62"
                          stroke="#999FA3"
                          stroke-width="1"
                        ></line>

                        <line
                          x1="256"
                          y1="64"
                          x2="270"
                          y2="67"
                          stroke="#999FA3"
                          stroke-width="1"
                        ></line>

                        <g fill="#4A0E11">
                          <rect
                            x="23"
                            y="54"
                            width="10"
                            height="12"
                            rx="1"
                          ></rect>

                          <rect
                            x="241"
                            y="29"
                            width="11"
                            height="12"
                            rx="1"
                          ></rect>

                          <rect
                            x="321"
                            y="48"
                            width="10"
                            height="12"
                            rx="1"
                          ></rect>

                          <rect
                            x="23"
                            y="181"
                            width="10"
                            height="11"
                            rx="1"
                          ></rect>

                          <rect
                            x="241"
                            y="159"
                            width="11"
                            height="12"
                            rx="1"
                          ></rect>

                          <rect
                            x="321"
                            y="177"
                            width="10"
                            height="11"
                            rx="1"
                          ></rect>
                        </g>

                        <polygon
                          points="
                    28,59
                    246,34
                    326,53
                    326,182
                    246,164
                    28,187
                  "
                          fill="none"
                          stroke="#521013"
                          stroke-width="3.2"
                          stroke-linejoin="round"
                        ></polygon>
                      </svg>
                    </span>
                  </span>

                  <h3>Contenedor Completo (FCL)</h3>

                  <span class="tf9-divider" aria-hidden="true"></span>

                  <p class="tf9-mode">
                    <i class="fa-solid fa-ship" aria-hidden="true"></i>

                    Vía marítima
                  </p>

                  <span class="tf9-action">
                    <span> Seleccionar </span>

                    <i class="fa-solid fa-arrow-right" aria-hidden="true"></i>
                  </span>
                </a>
              </article>

              <!-- =================================================
           03 — AÉREO
      ================================================== -->

              <article class="tf9-card tf9-card--air">
                <a
                  class="tf9-link"
                  @click="irARuta('AEREO')"
                  target="_blank"
                  rel="noopener"
                  aria-label="Seleccionar transporte vía aérea"
                >
                  <span class="tf9-number"> 03 </span>

                  <span class="tf9-icon-area">
                    <span class="tf9-icon-box">
                      <svg
                        class="tf9-air-svg"
                        viewBox="0 0 120 100"
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                      >
                        <ellipse
                          cx="60"
                          cy="84"
                          rx="39"
                          ry="5"
                          fill="#DCE8F2"
                        ></ellipse>

                        <path
                          d="
                    M105 48
                    C105 44 101 41 96 42
                    L72 48
                    L51 22
                    C49 20 46 19 43 20
                    L37 22
                    L49 54
                    L25 60
                    L15 51
                    C13 49 11 49 9 50
                    L5 52
                    L19 70
                    C21 73 25 74 29 73
                    L98 55
                    C102 54 105 52 105 48Z
                  "
                          fill="#173B64"
                        ></path>

                        <path
                          d="
                    M49 54
                    L72 48
                    L51 22
                    L43 24
                    L54 51Z
                  "
                          fill="#0878E8"
                        ></path>

                        <path
                          d="
                    M25 60
                    L15 51
                    L10 52
                    L19 65Z
                  "
                          fill="#2898E5"
                        ></path>

                        <circle cx="80" cy="49" r="2" fill="#FFFFFF"></circle>

                        <circle cx="87" cy="47.5" r="2" fill="#FFFFFF"></circle>

                        <circle cx="94" cy="46" r="2" fill="#FFFFFF"></circle>
                      </svg>
                    </span>
                  </span>

                  <h3>Carga aérea</h3>

                  <span class="tf9-divider" aria-hidden="true"></span>

                  <p class="tf9-mode">
                    <i class="fa-solid fa-plane" aria-hidden="true"></i>

                    Vía aérea
                  </p>

                  <span class="tf9-action">
                    <span> Seleccionar </span>

                    <i class="fa-solid fa-arrow-right" aria-hidden="true"></i>
                  </span>
                </a>
              </article>
            </div>
          </div>
        </section>
      </div>
    </div>
    <v-dialog
      v-model="actualizandoflag"
      max-width="440px"
      persistent
      transition="dialog-transition"
    >
      <v-card class="pa-6 text-center elevation-4 rounded-xl">
        <!-- Imagen representativa de importación / logística -->
        <v-img
          src="https://blogs.ucontinental.edu.pe/wp-content/uploads/2021/05/comercio-internacional-es-una-buena-idea-restringir-las-importaciones-universidad-continental-1.jpg"
          alt="Actualizando tarifas de importación"
          height="160"
          class="rounded-lg mb-4"
          cover
        ></v-img>

        <v-card-text class="pa-0">
          <!-- Título informativo -->
          <h3 class="text-h6 font-weight-bold mb-2 text-grey-darken-3">
            Actualizando tarifas
          </h3>

          <!-- Descripción de apoyo -->
          <p class="text-body-2 text-grey-darken-1 mb-0">
            Estamos actualizando nuestras tarifas marítimas para para después el
            feriado chino por favor regresar en 48 horas.
          </p>

          <a
            href="#"
            class="cdf-contact-button cdf-contact-button--tarifas"
            aria-haspopup="dialog"
            aria-controls="cdfhdrx-wa-modal"
            aria-label="Elegir un asesor por WhatsApp"
            @click.prevent="abrirContacto"
          >
            <span class="cdfsolo8-wa" aria-hidden="true">
              <svg viewBox="0 0 448 512">
                <path
                  d="M380.9 97.1C339 55.1 283.2 32 223.9 32 101.5 32 1.9 131.6 1.9 254c0 44.3 11.6 87.5 33.7 125.5L0 480l103.4-34.2c36.7 20.1 78 30.7 120.3 30.7h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.1-115-67-157.4zM223.9 438.7c-37.6 0-74.4-10.1-106.4-29.2l-7.4-4.4-61.4 20.3 20.6-59.8-4.8-7.7c-20.9-33.3-31.9-71.7-31.9-111.4 0-105.2 85.6-190.8 191-190.8 51 0 98.9 19.9 134.9 56 36 36.2 55.8 84.2 55.7 135.2-.1 105.2-85.8 190.9-190.3 190.9zm104.7-141.6c-5.7-2.8-33.8-16.6-39-18.5-5.2-1.9-9-2.8-12.8 2.8-3.8 5.7-14.7 18.5-18 22.3-3.3 3.8-6.6 4.3-12.3 1.4-33.6-16.8-55.7-30-77.9-68-5.9-10.2 5.9-9.5 16.8-31.7 1.9-3.8 1-7.1-.5-9.9-1.4-2.8-12.8-30.9-17.5-42.4-4.6-11.1-9.4-9.6-12.8-9.8-3.3-.2-7.1-.2-10.9-.2-3.8 0-9.9 1.4-15.2 7.1-5.2 5.7-19.9 19.5-19.9 47.6 0 28 20.4 55.2 23.2 59 2.8 3.8 40.1 61.2 97.1 85.8 36.1 15.6 50.2 16.9 68.2 14.2 10.9-1.6 33.8-13.8 38.6-27.1 4.8-13.3 4.8-24.7 3.3-27.1-1.3-2.5-5.1-3.8-10.8-6.6z"
                />
              </svg>
            </span>

            <span>Contáctanos</span>

            <span class="cdfsolo8-arrow" aria-hidden="true">
              <svg viewBox="0 0 24 24">
                <path d="M5 12h14"></path>
                <path d="m14 7 5 5-5 5"></path>
              </svg>
            </span>
          </a>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
import { mapActions } from "vuex";
export default {
  name: "HeroFleteTotal",
  data() {
    return {
      country: {
        name: "",
        code: "",
      },
      ip: "",
      actualizandoflag: false,
      error: null,
      prefix: "+51",
      codigo_iso: "PE",
      fletes: [
        {
          value: "LCL",
          titulo: "Flete Marítimo Consolidado (LCL)",
          tituloHtml:
            '<span class="tf9-title-line-mobile">Carga compartida /</span><span class="tf9-title-line-mobile">Consolidada o Grupal</span>',
          descripcion:
            "Ideal para cargas pequeñas: compartes contenedor y reduces costos.",
          img: "https://calculadoradefletes.comwp-content/uploads/2026/08/icono-carga-consolidada1.svg",
          claseIcono: "lcl",
          modo: "Vía marítima",
          iconoModo: "fa-ship",
          ruta: "FormularioFlete",
        },
        {
          value: "FCL",
          titulo: "Flete Marítimo Contenedor Completo (FCL)",
          tituloHtml: "CONTENEDOR <br>COMPLETO (FCL)",
          descripcion:
            "Para cargas grandes o exclusivas. Un contenedor solo para tu operación.",
          img: "https://calculadoradefletes.comwp-content/uploads/2026/08/icono-contenedor-fcl.svg",
          claseIcono: "fcl",
          modo: "Vía marítima",
          iconoModo: "fa-ship",
          ruta: "",
        },
        {
          value: "AEREO",
          titulo: "Flete Aéreo Internacional",
          tituloHtml: "AÉREO",
          descripcion:
            "La alternativa más rápida para productos urgentes o delicados.",
          img: "https://calculadoradefletes.comwp-content/uploads/2026/08/icono-carga-aerea.svg",
          claseIcono: "air",
          modo: "Vía aérea",
          iconoModo: "fa-plane",
          ruta: "",
        },
      ],
    };
  },
  mounted() {
    sessionStorage.clear();
    this.detectUserCountry();
    setTimeout(() => {
      // sessionStorage.setItem("id_port_destino", "CALLAO");
      // sessionStorage.setItem("id_pais_destino", 139);
      sessionStorage.setItem("prefix", this.prefix);
      sessionStorage.setItem("codigo_iso", this.codigo_iso);
    }, 100);
    this.obtenerMaximoValorOpcion()
  },
  methods: {
    ...mapActions('calculadora',["obtenerMaximoValorOpcion"]),
    abrirContacto() {
      this.$root.$emit("abrir-contacto-whatsapp");
    },
    async detectUserCountry() {
      // Mapeo basado en los IDs y prefijos de tu tabla
      const countryMap = {
        PE: { id: 139, prefix: "+51", codigo_iso: "PE" }, // Perú
        PA: { id: 136, prefix: "+507", codigo_iso: "PA" }, // Panamá
        VE: { id: 193, prefix: "+58", codigo_iso: "VE" }, // Venezuela
      };

      // Valores por defecto (fallback) si el país no está en la lista o falla la API
      const defaultData = countryMap.PE;

      try {
        const response = await axios.get("https://ipapi.co/json/");
        const code = response.data.country_code;

        this.country.name = response.data.country_name;
        this.country.code = code;
        this.ip = response.data.ip;

        // Buscar coincidencia en el mapa o tomar el fallback (Perú)
        const selected = countryMap[code] || defaultData;

        sessionStorage.setItem("id_pais_destino", selected.id);
        sessionStorage.setItem("prefix", selected.prefix);
        sessionStorage.setItem("codigo_iso", selected.codigo_iso);
      } catch (err) {
        this.error = "No se pudo obtener la geolocalización.";
        console.error(err);

        // En caso de error de la API, se aplican los valores por defecto
        sessionStorage.setItem("id_pais_destino", defaultData.id);
        sessionStorage.setItem("prefix", defaultData.prefix);
      } finally {
        this.loading = false;
      }
    },
    irARuta(value) {
      let flete = this.fletes.find((v) => v.value == value);

      if (flete) {
        sessionStorage.setItem("tipo", flete.value);

        if (!!flete.ruta) {
          this.$router.push({
            name: flete.ruta,
            params: {
              tipo: flete.value,
            },
          });
        } else {
          Swal.fire({
            html: `
    <div class="swal-proximamente">

      <div class="swal-icono-reloj">
        <i class="fa-regular fa-clock"></i>
      </div>

      <h2 class="swal-titulo">
        PRÓXIMAMENTE
      </h2>

      <div class="swal-linea"></div>

      <p class="swal-texto">
        Contenedor completo y carga aérea estarán disponibles muy pronto.
      </p>

      <p class="swal-texto-azul">
        Por ahora, cotiza tu carga LCL.
      </p>

    </div>
  `,

            showCloseButton: true,
            showConfirmButton: true,
            confirmButtonText: "COTIZAR CARGA LCL",

            width: "650px",

            backdrop: "rgba(7, 35, 75, 0.72)",

            customClass: {
              popup: "swal-popup-proximamente",
              closeButton: "swal-close-proximamente",
              confirmButton: "swal-confirm-proximamente",
            },

            buttonsStyling: false,

            allowOutsideClick: false,
            allowEscapeKey: true,
          }).then((result) => {
            if (result.isConfirmed) {
              this.irARuta("LCL");
            }
          });
        }
      }
    },
  },
};
</script>

<style>
.elementor-1665 {
  margin-top: 2%;
}
#cdf-tipo-flete-v9 {
  --tf-navy: #073763;
  --tf-navy-dark: #042e52;
  --tf-blue: #0878e8;

  --tf-text: #263746;
  --tf-muted: #657580;

  --tf-lcl: #147a66;
  --tf-lcl-soft: #f1faf7;
  --tf-lcl-border: #cbe5dd;

  --tf-fcl: #c52219;
  --tf-fcl-soft: #fff5f4;
  --tf-fcl-border: #edc7c3;

  --tf-air: #176fad;
  --tf-air-soft: #f1f7fb;
  --tf-air-border: #cce0ed;

  width: 100%;

  position: relative;
  overflow: hidden;

  padding: 38px 18px 52px;

  background: radial-gradient(
      circle at 0% 0%,
      rgba(8, 120, 232, 0.045) 0%,
      transparent 27%
    ),
    radial-gradient(
      circle at 100% 100%,
      rgba(7, 150, 105, 0.035) 0%,
      transparent 28%
    ),
    #ffffff;

  font-family: "Montserrat", sans-serif;

  color: var(--tf-text);
}

#cdf-tipo-flete-v9,
#cdf-tipo-flete-v9 *,
#cdf-tipo-flete-v9 *::before,
#cdf-tipo-flete-v9 *::after {
  box-sizing: border-box;
}

#cdf-tipo-flete-v9 .tf9-container {
  width: min(100%, 1120px);

  margin: 0 auto;

  position: relative;

  z-index: 2;
}

#cdf-tipo-flete-v9 .tf9-header {
  max-width: 850px;

  margin: 0 auto 38px;

  text-align: center;
}

#cdf-tipo-flete-v9 .tf9-label {
  display: inline-flex;

  align-items: center;
  justify-content: center;

  gap: 9px;

  margin: 0 0 13px;

  color: var(--tf-blue);

  font-size: 14px;
  line-height: 1.3;

  font-weight: 700;

  letter-spacing: 0.09em;

  text-transform: uppercase;
}

#cdf-tipo-flete-v9 .tf9-label i {
  color: var(--tf-blue);

  font-size: 16px;
}

#cdf-tipo-flete-v9 h2 {
  max-width: 760px;

  margin: 0 auto;

  color: var(--tf-navy);

  font-size: 38px;
  line-height: 1.15;

  font-weight: 700;

  letter-spacing: -0.8px;

  text-align: center;

  text-transform: none;
}

#cdf-tipo-flete-v9 .tf9-title-line {
  width: 48px;
  height: 2px;

  margin: 16px auto 0;

  border-radius: 999px;

  background: var(--tf-blue);

  opacity: 0.72;

  transform: scaleX(0.58);

  transform-origin: center;

  animation: tf9TitleLine 1.9s ease-in-out infinite;
}

@keyframes tf9TitleLine {
  0%,
  100% {
    transform: scaleX(0.58);
    opacity: 0.72;
  }

  50% {
    transform: scaleX(1);
    opacity: 1;
  }
}

#cdf-tipo-flete-v9 .tf9-grid {
  display: grid;

  grid-template-columns: repeat(3, minmax(0, 1fr));

  gap: 18px;
}

#cdf-tipo-flete-v9 .tf9-card {
  --accent: var(--tf-lcl);
  --soft: var(--tf-lcl-soft);
  --card-border: var(--tf-lcl-border);

  min-width: 0;

  position: relative;
  overflow: hidden;

  border: 1.5px solid var(--card-border);

  border-radius: 8px;

  background: #ffffff;

  box-shadow: 0 8px 24px rgba(7, 55, 99, 0.065);

  transition: transform 0.23s ease, box-shadow 0.23s ease,
    border-color 0.23s ease;
}

#cdf-tipo-flete-v9 .tf9-card--lcl {
  --accent: var(--tf-lcl);
  --soft: var(--tf-lcl-soft);
  --card-border: var(--tf-lcl-border);
}

#cdf-tipo-flete-v9 .tf9-card--fcl {
  --accent: var(--tf-fcl);
  --soft: var(--tf-fcl-soft);
  --card-border: var(--tf-fcl-border);
}

#cdf-tipo-flete-v9 .tf9-card--air {
  --accent: var(--tf-air);
  --soft: var(--tf-air-soft);
  --card-border: var(--tf-air-border);
}

#cdf-tipo-flete-v9 .tf9-card::before {
  content: "";

  position: absolute;

  top: 0;
  left: 0;

  width: 100%;
  height: 5px;

  background: var(--accent);

  z-index: 4;
}

#cdf-tipo-flete-v9 .tf9-card:hover {
  transform: translateY(-5px);

  border-color: var(--accent);

  box-shadow: 0 18px 40px rgba(7, 55, 99, 0.13);
}

#cdf-tipo-flete-v9 .tf9-link {
  min-height: 350px;

  padding: 25px 24px 22px;

  position: relative;

  display: flex;
  flex-direction: column;

  align-items: center;

  color: inherit;

  text-decoration: none !important;

  transition: background 0.23s ease;
}

#cdf-tipo-flete-v9 .tf9-card:hover .tf9-link {
  background: linear-gradient(180deg, var(--soft) 0%, #ffffff 74%);
}

#cdf-tipo-flete-v9 .tf9-number {
  position: absolute;

  top: 16px;
  left: 16px;

  z-index: 5;

  min-width: 38px;
  height: 30px;

  padding: 0 9px;

  display: flex;

  align-items: center;
  justify-content: center;

  border: 1px solid var(--accent);

  border-radius: 5px;

  background: var(--accent);

  color: #ffffff;

  font-size: 11px;
  line-height: 1;

  font-weight: 800;

  letter-spacing: 0.4px;
}

#cdf-tipo-flete-v9 .tf9-icon-area {
  width: 100%;

  display: flex;

  justify-content: center;

  margin: 36px 0 16px;
}

#cdf-tipo-flete-v9 .tf9-icon-box {
  width: 126px;
  height: 116px;

  display: flex;

  align-items: center;
  justify-content: center;

  position: relative;

  overflow: hidden;

  border: 1px solid rgba(7, 55, 99, 0.1);

  border-radius: 12px;

  background: #ffffff;

  transition: box-shadow 0.22s ease;
}

#cdf-tipo-flete-v9 .tf9-card:hover .tf9-icon-box {
  box-shadow: 0 8px 20px rgba(7, 55, 99, 0.08);
}

#cdf-tipo-flete-v9 .tf9-icon-box svg {
  display: block;

  position: relative;

  z-index: 2;

  overflow: visible;

  animation: tf9Float 3.1s ease-in-out infinite;
}

@keyframes tf9Float {
  0%,
  100% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-4px);
  }
}

#cdf-tipo-flete-v9 .tf9-lcl-svg {
  width: 118px;
  height: 95px;
}

#cdf-tipo-flete-v9 .tf9-fcl-svg {
  width: 122px;
  height: 96px;
}

#cdf-tipo-flete-v9 .tf9-air-svg {
  width: 108px;
  height: 108px;
}

#cdf-tipo-flete-v9 .tf9-card h3 {
  width: 100%;

  min-height: 60px;

  margin: 0;

  display: flex;

  align-items: center;
  justify-content: center;

  color: #0b2a50;

  font-size: 24px;
  line-height: 1.16;

  font-weight: 800;

  letter-spacing: -0.5px;

  text-align: center;

  text-transform: none;
}

/* PRIMERA CARD: TÍTULO ORDENADO EN PC / TABLET */
#cdf-tipo-flete-v9 .tf9-card--lcl h3 {
  flex-direction: column;
  gap: 0;
}

#cdf-tipo-flete-v9 .tf9-title-line-mobile {
  display: block;
  width: 100%;
  white-space: nowrap;
  text-align: center;
}

#cdf-tipo-flete-v9 .tf9-divider {
  width: 38px;
  height: 2px;

  display: block;

  margin: 14px auto 13px;

  border-radius: 999px;

  background: var(--accent);
}

#cdf-tipo-flete-v9 .tf9-mode {
  width: 100%;

  margin: 0;

  display: flex;

  align-items: center;
  justify-content: center;

  gap: 7px;

  color: var(--tf-muted);

  font-size: 14px;
  line-height: 1.45;

  font-weight: 600;

  text-align: center;
}

#cdf-tipo-flete-v9 .tf9-mode i {
  color: var(--accent);

  font-size: 14px;
}

#cdf-tipo-flete-v9 .tf9-action {
  margin-top: 19px;

  min-width: 138px;
  min-height: 38px;

  padding: 0 11px 0 14px;

  display: inline-flex;

  align-items: center;
  justify-content: space-between;

  gap: 18px;

  border: 1px solid var(--accent);

  border-radius: 4px;

  background: #ffffff;

  color: var(--accent);

  font-size: 13px;
  line-height: 1;

  font-weight: 800;

  letter-spacing: 0.5px;

  text-transform: uppercase;

  white-space: nowrap;
}

#cdf-tipo-flete-v9 .tf9-action i {
  margin-left: auto;

  font-size: 12px;
}

#cdf-tipo-flete-v9 .tf9-card:hover .tf9-action {
  background: var(--accent);

  color: #ffffff;
}

/* =====================================================
       TABLET
    ===================================================== */

@media (max-width: 991px) {
  #cdf-tipo-flete-v9 {
    padding: 40px 22px 48px;
  }

  #cdf-tipo-flete-v9 h2 {
    font-size: 34px;
  }

  #cdf-tipo-flete-v9 .tf9-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  #cdf-tipo-flete-v9 .tf9-card:last-child {
    grid-column: 1 / -1;

    width: 100%;
    max-width: 540px;

    justify-self: center;
  }

  #cdf-tipo-flete-v9 .tf9-link {
    min-height: 340px;
  }
}

/* =====================================================
       MÓVIL
    ===================================================== */

@media (max-width: 640px) {
  #cdf-tipo-flete-v9 {
    padding: 24px 12px 38px;
  }

  #cdf-tipo-flete-v9 .tf9-header {
    margin-bottom: 27px;
  }

  #cdf-tipo-flete-v9 .tf9-label {
    gap: 7px;

    margin-bottom: 10px;

    font-size: 11px;

    letter-spacing: 0.08em;
  }

  #cdf-tipo-flete-v9 .tf9-label i {
    font-size: 13px;
  }

  #cdf-tipo-flete-v9 h2 {
    font-size: 28px;
    line-height: 1.18;
  }

  #cdf-tipo-flete-v9 .tf9-title-line {
    width: 42px;

    margin-top: 14px;
  }

  #cdf-tipo-flete-v9 .tf9-grid {
    display: flex;

    flex-direction: column;

    gap: 14px;
  }

  #cdf-tipo-flete-v9 .tf9-card:last-child {
    width: 100%;
    max-width: none;
  }

  #cdf-tipo-flete-v9 .tf9-card {
    width: 100%;

    min-height: 176px;

    border-width: 1px;

    border-radius: 8px;

    box-shadow: 0 5px 15px rgba(7, 55, 99, 0.07);
  }

  #cdf-tipo-flete-v9 .tf9-card::before {
    top: 0;
    left: 0;

    width: 55px;
    height: 100%;
  }

  /* MÁS ESPACIO PARA EL TEXTO */

  #cdf-tipo-flete-v9 .tf9-link {
    width: 100%;

    min-height: 176px;

    padding: 15px 13px 15px 66px;

    display: grid;

    grid-template-columns:
      86px
      minmax(0, 1fr);

    grid-template-rows:
      auto
      auto
      auto
      auto;

    column-gap: 8px;

    align-items: center;

    background: #ffffff;
  }

  #cdf-tipo-flete-v9 .tf9-card:hover .tf9-link {
    background: #ffffff;
  }

  #cdf-tipo-flete-v9 .tf9-number {
    top: 26px;
    left: 0;

    width: 55px;
    min-width: 55px;
    height: 28px;

    padding: 0;

    border: 0;

    border-radius: 0;

    background: transparent;

    color: #ffffff;

    font-size: 20px;

    font-weight: 700;
  }

  /* ===================================================
         CUADRO MÁS COMPACTO
         IMAGEN MÁS GRANDE
      =================================================== */

  #cdf-tipo-flete-v9 .tf9-icon-area {
    width: 86px;

    margin: 0;

    grid-column: 1;
    grid-row: 1 / 5;

    align-self: start;
  }

  #cdf-tipo-flete-v9 .tf9-icon-box {
    width: 86px;
    height: 90px;

    border-radius: 9px;
  }

  /* MÁS IMAGEN Y MENOS AIRE */

  #cdf-tipo-flete-v9 .tf9-lcl-svg {
    width: 84px;
    height: 70px;
  }

  #cdf-tipo-flete-v9 .tf9-fcl-svg {
    width: 86px;
    height: 70px;
  }

  #cdf-tipo-flete-v9 .tf9-air-svg {
    width: 84px;
    height: 84px;
  }

  #cdf-tipo-flete-v9 .tf9-card h3 {
    grid-column: 2;
    grid-row: 1;

    width: 100%;

    min-width: 0;
    min-height: auto;

    margin: 0;

    display: block;

    align-self: end;

    color: #0b2a50;

    font-size: 16px;
    line-height: 1.18;

    font-weight: 800;

    letter-spacing: -0.3px;

    text-align: left;

    word-break: normal;
    overflow-wrap: normal;
  }

  #cdf-tipo-flete-v9 .tf9-card h3 br {
    display: none;
  }

  /* PRIMER TÍTULO:
         DOS LÍNEAS EXACTAS */

  #cdf-tipo-flete-v9 .tf9-card--lcl h3 {
    font-size: 16px;
    line-height: 1.18;

    letter-spacing: -0.3px;
  }

  #cdf-tipo-flete-v9 .tf9-card--lcl h3 .tf9-title-line-mobile {
    display: block;

    width: 100%;

    white-space: nowrap;

    text-align: left;
  }

  #cdf-tipo-flete-v9 .tf9-divider {
    grid-column: 2;
    grid-row: 2;

    width: 30px;

    margin: 10px 0 9px;

    justify-self: start;
  }

  #cdf-tipo-flete-v9 .tf9-mode {
    grid-column: 2;
    grid-row: 3;

    justify-content: flex-start;

    font-size: 13px;

    text-align: left;
  }

  #cdf-tipo-flete-v9 .tf9-mode i {
    display: none;
  }

  #cdf-tipo-flete-v9 .tf9-action {
    grid-column: 2;
    grid-row: 4;

    width: 136px;

    min-width: 136px;
    min-height: 34px;

    margin: 17px auto 0 0;

    padding: 0 10px 0 12px;

    font-size: 11px;

    gap: 10px;

    justify-content: space-between;
  }

  #cdf-tipo-flete-v9 .tf9-action i {
    margin-left: auto;

    font-size: 11px;
  }

  #cdf-tipo-flete-v9 .tf9-card:hover {
    transform: none;
  }

  #cdf-tipo-flete-v9 .tf9-card:hover .tf9-action {
    background: #ffffff;

    color: var(--accent);
  }
}

/* =====================================================
       MÓVIL PEQUEÑO
    ===================================================== */

@media (max-width: 390px) {
  #cdf-tipo-flete-v9 {
    padding-left: 10px;
    padding-right: 10px;
  }

  #cdf-tipo-flete-v9 h2 {
    font-size: 27px;
  }

  #cdf-tipo-flete-v9 .tf9-card::before {
    width: 50px;
  }

  #cdf-tipo-flete-v9 .tf9-number {
    width: 50px;
    min-width: 50px;

    font-size: 19px;
  }

  #cdf-tipo-flete-v9 .tf9-link {
    padding: 14px 10px 14px 59px;

    grid-template-columns:
      86px
      minmax(0, 1fr);

    column-gap: 8px;
  }

  #cdf-tipo-flete-v9 .tf9-icon-area {
    width: 86px;

    align-self: start;
  }

  #cdf-tipo-flete-v9 .tf9-icon-box {
    width: 86px;
    height: 88px;
  }

  #cdf-tipo-flete-v9 .tf9-lcl-svg {
    width: 84px;
    height: 70px;
  }

  #cdf-tipo-flete-v9 .tf9-fcl-svg {
    width: 85px;
    height: 70px;
  }

  #cdf-tipo-flete-v9 .tf9-air-svg {
    width: 82px;
    height: 82px;
  }

  #cdf-tipo-flete-v9 .tf9-card h3 {
    font-size: 15.5px;
  }

  #cdf-tipo-flete-v9 .tf9-card--lcl h3 {
    font-size: 15.5px;

    letter-spacing: -0.3px;
  }

  #cdf-tipo-flete-v9 .tf9-action {
    width: 126px;
    min-width: 126px;

    font-size: 10px;
  }
}

@media (prefers-reduced-motion: reduce) {
  #cdf-tipo-flete-v9 .tf9-title-line,
  #cdf-tipo-flete-v9 .tf9-card,
  #cdf-tipo-flete-v9 .tf9-icon-box svg {
    animation: none !important;

    transition: none !important;
  }
}

.cdf-contact-button--tarifas {
  background: #43A047 !important;
}
/* SOLO AGRANDA LOS DIBUJOS INTERNOS EN MÓVIL.
   NO CAMBIA EL TAMAÑO DEL CUADRO BLANCO. */

#cdf-tipo-flete-v9 .tf9-lcl-svg {
  scale: 1.14;
}

#cdf-tipo-flete-v9 .tf9-fcl-svg {
  scale: 1.1;
}

#cdf-tipo-flete-v9 .tf9-air-svg {
  scale: 1.12;
}

/* Estilos personalizados para SweetAlert */
.swal-custom-popup {
  border-radius: 12px !important;
  box-shadow: 0 10px 40px rgba(7, 55, 99, 0.2) !important;
  padding: 32px 28px !important;
  max-width: 500px !important;
}

.swal-custom-popup .swal2-icon {
  margin: 0 auto 16px !important;
}

.swal-custom-popup .swal2-title {
  font-size: 28px !important;
  font-weight: 800 !important;
  color: #0f2c59 !important;
  margin-bottom: 12px !important;
}

.swal-custom-popup .swal2-html-container {
  text-align: center !important;
  color: #263746 !important;
  font-size: 15px !important;
  line-height: 1.6 !important;
  margin: 0 !important;
}

.swal-custom-popup .swal2-close {
  width: 28px !important;
  height: 28px !important;
  top: 16px !important;
  right: 16px !important;
  color: #0878e8 !important;
}

.swal-custom-confirm {
  background-color: #0878e8 !important;
  color: #ffffff !important;
  font-weight: 700 !important;
  font-size: 14px !important;
  padding: 12px 24px !important;
  border-radius: 6px !important;
  letter-spacing: 0.5px !important;
  text-transform: uppercase !important;
}

.swal-custom-confirm:hover {
  background-color: #0762c8 !important;
}

/* CONTENEDOR DEL SWAL */
.swal-popup-proximamente {
  border-radius: 14px !important;
  padding: 36px 45px 34px !important;
  box-sizing: border-box;
}

/* BOTÓN X */
.swal-close-proximamente {
  color: #08285c !important;
  font-size: 34px !important;
  font-weight: 700 !important;
  width: 45px !important;
  height: 45px !important;
  margin-top: 5px !important;
  margin-right: 8px !important;
}

.swal-close-proximamente:hover {
  color: #1267df !important;
}

/* CONTENIDO */
.swal-proximamente {
  text-align: center;
  font-family: "Montserrat", sans-serif;
}

/* RELOJ */
.swal-icono-reloj {
  color: #1267df;
  font-size: 70px;
  line-height: 1;
  margin-bottom: 14px;
}

.swal-icono-reloj i {
  font-weight: 400;
}

/* TÍTULO */
.swal-titulo {
  margin: 0;
  color: #06265a;
  font-size: 44px;
  font-weight: 900;
  line-height: 1.1;
  letter-spacing: -1px;
}

/* LÍNEA AZUL */
.swal-linea {
  width: 130px;
  height: 10px;
  background: #1267df;
  border-radius: 10px;
  margin: 18px auto 22px;
}

/* TEXTO */
.swal-texto {
  margin: 0 auto;
  color: #09285b;
  font-size: 18px;
  font-weight: 500;
  line-height: 1.5;
}

/* TEXTO AZUL */
.swal-texto-azul {
  margin: 20px 0 28px;
  color: #1267df;
  font-size: 20px;
  font-weight: 800;
}

/* BOTÓN */
.swal-confirm-proximamente {
  display: block;
  width: 380px;
  max-width: 100%;
  margin: 0 auto;
  padding: 17px 25px;
  border: none;
  border-radius: 9px;

  background: #0969e8;
  color: white !important;

  font-family: "Montserrat", sans-serif;
  font-size: 18px;
  font-weight: 800;
  letter-spacing: 0.5px;
  cursor: pointer;
  box-shadow: none;
}

.swal-confirm-proximamente:hover {
  background: #075dcc;
}

.swal-confirm-proximamente:focus {
  outline: none;
  box-shadow: none;
}

/* =========================================
   POPUP PRÓXIMAMENTE
   ========================================= */

.swal-popup-proximamente {
  width: 650px !important;
  max-width: calc(100vw - 30px) !important;
  box-sizing: border-box;
  padding: 40px 45px 35px !important;
  border-radius: 18px !important;
}

/* Contenido */
.swal-proximamente {
  width: 100%;
  box-sizing: border-box;
}

/* Icono */
.swal-icono-reloj {
  width: 75px;
  height: 75px;
  margin: 0 auto 20px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 50%;

  background: #eef5ff;
  color: #1461a7;

  font-size: 36px;
}

/* Título */
.swal-titulo {
  margin: 0;

  font-size: 32px;
  line-height: 1.2;
  font-weight: 800;

  color: #073b7a;

  text-align: center;
}

/* Línea */
.swal-linea {
  width: 80px;
  height: 4px;

  margin: 18px auto 22px;

  background: #1461a7;
  border-radius: 10px;
}

/* Texto */
.swal-texto {
  margin: 0 auto 12px;

  max-width: 500px;

  font-size: 17px;
  line-height: 1.6;

  color: #555;

  text-align: center;
}

/* Texto azul */
.swal-texto-azul {
  margin: 0 auto;

  font-size: 18px;
  line-height: 1.5;
  font-weight: 700;

  color: #1461a7;

  text-align: center;
}

/* Botón */
.swal-confirm-proximamente {
  min-width: 230px;

  margin-top: 25px;
  padding: 13px 25px;

  border: none;
  border-radius: 8px;

  background: #1461a7;
  color: #fff;

  font-size: 15px;
  font-weight: 700;

  cursor: pointer;

  transition: all 0.2s ease;
}

.swal-confirm-proximamente:hover {
  background: #073b7a;
  transform: translateY(-1px);
}

/* Botón cerrar */
.swal-close-proximamente {
  font-size: 28px !important;
  color: #777 !important;
}

/* =========================================
   TABLET
   ========================================= */

@media (max-width: 768px) {
  .swal-popup-proximamente {
    width: calc(100vw - 30px) !important;
    max-width: calc(100vw - 30px) !important;

    padding: 35px 25px 30px !important;

    border-radius: 16px !important;
  }

  .swal-icono-reloj {
    width: 65px;
    height: 65px;

    margin-bottom: 17px;

    font-size: 30px;
  }

  .swal-titulo {
    font-size: 27px;
  }

  .swal-linea {
    margin: 15px auto 18px;
  }

  .swal-texto {
    font-size: 16px;
    line-height: 1.5;
  }

  .swal-texto-azul {
    font-size: 17px;
  }

  .swal-confirm-proximamente {
    min-width: 210px;
    padding: 12px 20px;
  }
}

/* =========================================
   CELULAR
   ========================================= */

@media (max-width: 480px) {
  .swal-popup-proximamente {
    width: calc(100vw - 20px) !important;
    max-width: calc(100vw - 20px) !important;

    padding: 30px 18px 25px !important;

    border-radius: 14px !important;
  }

  .swal-icono-reloj {
    width: 58px;
    height: 58px;

    margin-bottom: 15px;

    font-size: 26px;
  }

  .swal-titulo {
    font-size: 23px;
  }

  .swal-linea {
    width: 65px;
    height: 3px;

    margin: 13px auto 17px;
  }

  .swal-texto {
    font-size: 14px;
    line-height: 1.5;
  }

  .swal-texto-azul {
    font-size: 15px;
    line-height: 1.4;
  }

  .swal-confirm-proximamente {
    width: 100%;
    min-width: 0;

    margin-top: 22px;
    padding: 13px 15px;

    font-size: 14px;
  }

  .swal-close-proximamente {
    font-size: 24px !important;
  }
}
</style>
